'use strict';

module.exports = require('./components/DisqusThread');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-disqus-thread/lib/main.js
 ** module id = 939
 ** module chunks = 0
 **/